var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277 101.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #1f140f;\n      }\n\n      .cls-3 {\n        fill: #373737;\n      }\n\n      .cls-4 {\n        fill: #00406d;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #009276;\n      }\n\n      .cls-7 {\n        fill: #e13648;\n      }\n\n      .cls-8 {\n        fill: #5c5b5f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 514.8,
    y: -54.6,
    width: 595.3,
    height: 213
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "127.5 -214.9 139.6 -214.9 139.6 -217.4 127.5 -217.4 127.5 -225.3 141 -225.3 141 -227.8 124.8 -227.8 124.8 -204.1 141.5 -204.1 141.5 -206.6 127.5 -206.6 127.5 -214.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M147.1-218.9c1-.6,2.1-.8,3.3-.8s1.9.2,2.8.6c.8.4,1.5,1,2.1,1.7l.3.4,2-1.5-.3-.4c-.7-1.1-1.7-1.9-2.9-2.5s-2.5-.8-3.9-.8-3.3.4-4.7,1.2-2.5,1.9-3.3,3.3c-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7,1.9,2.5,3.2,3.3c1.4.8,2.9,1.2,4.7,1.2s2.8-.3,3.9-.8c1.2-.6,2.2-1.4,2.9-2.5l.3-.4-2-1.5-.3.4c-.6.8-1.2,1.4-2.1,1.7-.8.4-1.8.6-2.8.6s-2.3-.3-3.3-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.9-212.5c0,1.9-.5,3.4-1.5,4.5s-2.4,1.6-4.2,1.6-2.9-.5-3.8-1.3c-.9-.9-1.3-2.2-1.3-4v-10.3h-2.6v10.4c0,2.4.7,4.4,2,5.7s3.2,2,5.6,2,3-.4,4.2-1.1c.7-.4,1.3-.9,1.8-1.5v2.4h2.6v-18h-2.6v9.5h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184-222.2c-1.4,0-2.7.2-3.9.7-1.2.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1-1.2-1.2-3-1.7-5.2-1.7h-.1ZM186.4-207.2c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M207.7-219.2c-.6-.7-1.3-1.3-2.1-1.8-1.3-.8-2.7-1.1-4.3-1.1s-3.2.4-4.5,1.2c-1.4.8-2.4,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7,1.8,2.5,3.2,3.2c1.4.8,2.9,1.2,4.5,1.2s3.1-.4,4.4-1.1c.8-.5,1.5-1.1,2.1-1.8v2.8h2.6v-25.2h-2.6v10h0ZM206.9-216.5c.6,1,.8,2.2.8,3.5s-.3,2.5-.8,3.5c-.6,1-1.3,1.8-2.3,2.3-.9.6-2,.8-3.2.8s-2.3-.3-3.2-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.3,2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.3-221c-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2c-1.4.8-2.5,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7,1.9,2.5,3.2,3.3c1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2c1.4-.8,2.5-1.9,3.2-3.3.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7-1.9-2.5-3.2-3.3ZM227.1-213.1c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3s-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.7-222.2c-1.7,0-3.1.4-4.3,1.1-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.5-170.1h-13.1l-2.5,6.1h-6.7l12.6-28.3h6.5l12.6,28.3h-6.9l-2.5-6.1h0ZM141.4-175.1l-4.5-10.8-4.5,10.8h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.1-178.6h6v11.5c-1.5,1.2-3.3,2-5.3,2.7-2,.6-4.1.9-6.1.9-2.9,0-5.6-.6-7.9-1.9s-4.2-3-5.5-5.2-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.6-5.2c2.4-1.3,5-1.9,8-1.9s4.7.4,6.7,1.3c2,.8,3.7,2,5.1,3.6l-4.2,3.9c-2-2.1-4.5-3.2-7.3-3.2s-3.4.4-4.8,1.1c-1.4.8-2.5,1.8-3.3,3.2s-1.2,2.9-1.2,4.7.4,3.3,1.2,4.7,1.9,2.4,3.3,3.2c1.4.8,3,1.2,4.7,1.2s3.6-.4,5.1-1.2v-8.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.6-164l-5.5-7.9h-6v7.9h-6.5v-28.3h12.2c2.5,0,4.7.4,6.5,1.3,1.8.8,3.3,2,4.3,3.6,1,1.5,1.5,3.4,1.5,5.5s-.5,3.9-1.5,5.4-2.4,2.7-4.3,3.5l6.3,9.1h-7ZM197.9-185.7c-1-.8-2.5-1.3-4.5-1.3h-5.3v9.9h5.3c2,0,3.5-.4,4.5-1.3,1-.9,1.5-2.1,1.5-3.6s-.5-2.8-1.5-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.9-165.5c-2.4-1.3-4.2-3-5.5-5.2s-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.5-5.2c2.4-1.3,5-1.9,7.9-1.9s5.6.6,7.9,1.9c2.3,1.3,4.2,3,5.5,5.2s2,4.7,2,7.5-.7,5.3-2,7.5-3.2,4-5.5,5.2c-2.3,1.3-5,1.9-7.9,1.9s-5.6-.6-7.9-1.9ZM228.3-170.3c1.3-.8,2.4-1.8,3.2-3.2s1.2-2.9,1.2-4.7-.4-3.3-1.2-4.7-1.8-2.4-3.2-3.2c-1.3-.8-2.9-1.2-4.5-1.2s-3.2.4-4.5,1.2-2.4,1.8-3.2,3.2-1.2,2.9-1.2,4.7.4,3.3,1.2,4.7,1.8,2.4,3.2,3.2c1.3.8,2.9,1.2,4.5,1.2s3.2-.4,4.5-1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.4-149.8c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5,1-.4,2-.6,3.1-.6s2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9c1.2,1,2.8,1.4,4.8,1.4s2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1-1.2-1.2-3-1.7-5.2-1.7h-.1ZM132.8-134.7c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.5,
    y: -156.8,
    width: 2.6,
    height: 25.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 146.4,
    y: -149.6,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.4-155.9c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M174-149.8c-1.7,0-3.2.4-4.5,1.2-1,.6-1.8,1.4-2.3,2.3-.5-1-1.2-1.8-2.1-2.3-1.2-.7-2.6-1.1-4.2-1.1s-3.1.4-4.2,1.1c-.7.4-1.3.9-1.8,1.5v-2.4h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3c.8.9,1.3,2.3,1.3,4v10.3h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3c.8.9,1.3,2.3,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-1.9-5.7-1.3-1.3-3.1-2-5.3-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M195.5-148.6c-1.3-.8-2.8-1.2-4.4-1.2s-3.1.4-4.4,1.2c-1.3.8-2.4,1.9-3.1,3.3-.7,1.4-1.1,3-1.1,4.7s.4,3.3,1.2,4.7,1.9,2.5,3.3,3.2c1.4.8,3,1.2,4.8,1.2s2.7-.3,3.8-.8c1.2-.5,2.2-1.2,3-2.2l.3-.3-1.6-1.8-.4.5c-.6.7-1.3,1.3-2.2,1.6-.9.4-1.8.6-2.9.6s-2.4-.3-3.4-.8-1.8-1.3-2.4-2.2c-.5-.8-.8-1.7-.9-2.8h14.5v-1c0-1.7-.3-3.3-1.1-4.7-.7-1.4-1.8-2.5-3.1-3.2h0ZM185.2-142c.1-.9.4-1.8.9-2.5.5-.9,1.2-1.6,2.1-2.1,1.8-1,4.2-1,6,0,.9.5,1.6,1.2,2.1,2.1.5.7.7,1.6.9,2.5h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210-149.8c-1.7,0-3.1.4-4.4,1.1-.7.4-1.4.9-1.9,1.6v-2.5h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.6-4.5,1-1.1,2.5-1.6,4.4-1.6s2.8.4,3.7,1.3c.9.9,1.3,2.2,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-2-5.7s-3.1-2-5.4-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.4-134.7c-.6.5-1.4.8-2.3.8s-1.6-.2-2-.7-.7-1.2-.7-2.2v-10.4h5.4v-2.4h-5.4v-3.7h-2.6v3.7h-3.1v2.4h3.1v10.6c0,1.6.5,2.8,1.3,3.8.9.9,2.2,1.4,3.8,1.4s1.4-.1,2.1-.3c.7-.2,1.3-.6,1.7-1l.3-.3-1.2-2-.5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M237.1-149.8c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1-1.2-1.2-3-1.7-5.2-1.7h-.1ZM239.5-134.7c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M251.5-148.7c-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5c-1.7,0-3.1.4-4.3,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M257.2-155.9c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 257.1,
    y: -149.6,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278-145.3c-.8-1.4-1.9-2.5-3.2-3.3-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2-2.5,1.9-3.2,3.3c-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2,2.5-1.9,3.2-3.3c.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7ZM276.5-140.6c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3-.6-1-.8-2.2-.8-3.5s.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.8,
    y1: -120.1,
    x2: 282.9,
    y2: -120.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118.8,
    y: -120.6,
    width: 164.1,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.7-200.9c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53-227.2c-16.1,0-30.4,8.1-38.9,20.5,1.7-.2,3.3-.3,5-.3,5.4,0,10.7.9,15.5,2.6,5.2-3.7,11.5-5.8,18.3-5.8s13.1,2.1,18.3,5.8c4.8-1.7,10-2.6,15.4-2.6s3.5,0,5.2.3c-8.5-12.4-22.7-20.5-38.9-20.5h.1ZM72.2-210.8c-5.8-3.4-12.3-5.2-19.1-5.2s-13.4,1.8-19.2,5.3c-2.2-.6-4.4-1.1-6.7-1.5,7.2-5.8,16.3-9.1,25.9-9.1s18.6,3.3,25.8,9.1c-2.3.3-4.5.8-6.7,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.7-200.9c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.7-200.9c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.5-200.5c-1.6-.1-3.1-.2-4.7-.2-14.7,0-28,6-37.5,15.7-9.6-9.7-22.8-15.7-37.5-15.7s-3.5,0-5.2.3c-.9,1.9-1.7,3.8-2.3,5.8,2.8-.5,5.7-.8,8.7-.8,13,0,24.8,5.3,33.3,13.8s2,2.1,2.9,3.2c1-1.1,2-2.2,3-3.3,8.5-8.5,20.2-13.7,33.2-13.7s5.7.3,8.4.8c-.6-2-1.4-3.9-2.3-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.2-174.6H6.3c-.2-1.8-.3-3.6-.3-5.5s0-3.7.3-5.4l10.9,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.5-188.1v11.1l-11.1-11.1c1.9-.2,3.8-.4,5.8-.4s3.6.1,5.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.5-160.3H10.3c-1.6-3.5-2.8-7.2-3.6-11.1h13.7l11.1,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.9-184.1v21.5l-11.1-11.1v-13.9c3.9.7,7.6,1.9,11.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.9-145.9h-25.2c-3.4-3.2-6.3-7-8.7-11.1h22.8l11.1,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.2-173.8v25.6l-11.1-11.1v-23.1c4.1,2.3,7.9,5.2,11.1,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.5-133.3c-1.8.2-3.6.3-5.4.3s-5.1-.2-7.6-.6c-3-.5-5.8-1.2-8.6-2.2-4.5-1.6-8.6-3.9-12.4-6.8h24.7s9.3,9.3,9.3,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.2-141.3c0,2,0,3.9-.3,5.8l-9.4-9.4v-25.1c.5.7,1,1.4,1.5,2.1,5.2,7.6,8.2,16.7,8.2,26.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 80.5,
    y: -176.4,
    width: 3.1,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.3-177.9c0-.9.7-1.6,1.6-1.6h6.2c.9,0,1.6.7,1.6,1.6v8h4.7v-12.1c0-.4-.2-.8-.5-1.1l-2.5-2.5c0-.1-.3-.2-.4-.3l-3.8-2h0c-2.7.5-5.6,1.2-8.6,2.4l-2.5,2.5c-.3.3-.5.7-.5,1.1v12.1h4.7v-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83-154.3h-16.9c.3,1,.6,2,.9,3.1h12.8l3.1-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.4-135.9s4-1.3,9.2-4.6c4.7-3,10.4-7.7,14.7-14.6,1.7-2.8,3.3-5.9,4.4-9.4-6.3,6.2-24.1,24-28.3,28.2v.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.2-160.5h-25.4c.4,1,.8,2,1.2,3.1h21l3.1-3.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.7-148h-8.9c.2,1,.4,2.1.6,3.1h5.2s3.1-3.1,3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.9-141.8c0,.4,0,.9.2,1.3l1.3-1.3h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.4-166.8h-34.6c.5.9,1,2,1.6,3.1h29.9l3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.2-185.3c.7.7,1.2,1.7,1.3,2.7h5.5c0-1.5-.2-3.1-.4-4.7v-.4s-.5-.1-1.4-.3h0c-1.6-.3-4.6-.6-8.3-.4.3.2.6.4.9.7l2.5,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.5-179.5v9.6h4.5c.6-3,.9-6.1.9-9.6h-5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.2-169.9v-3.5c3.6-.6,6.2-3.1,6.2-6.1s-.2-1.8-.6-2.8c-3.6,2.1-7.2,4.8-10.8,8.4.6.3,1.3.5,2,.6v3.5h3.2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.4-108.3v1.6h4v1.7h-4v1.7h4.5v1.7h-6.6v-8.3h6.5v1.7h-4.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.4-106.6l-1.5.9c-.3-.4-.7-.7-1.3-.7s-1.3.7-1.3,1.6.5,1.6,1.3,1.6,1-.2,1.3-.7l1.5.9c-.5.9-1.6,1.5-2.9,1.5-2,0-3.3-1.3-3.3-3.2s1.3-3.3,3.3-3.3,2.3.5,2.8,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.1-101.6h-2v-1.1c-.4.8-1.1,1.1-2.1,1.1s-2.3-.9-2.3-2.4v-4h2v3.4c0,.8.4,1.2,1.1,1.2s1.2-.7,1.2-1.5v-3.1h2v6.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.9-105.8v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h-.1ZM147.9-103.8v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.3-101.6h-2v-.8c-.5.6-1.1.9-1.9.9-1.8,0-3-1.3-3-3.3s1.2-3.2,2.9-3.2,1.5.3,2,.9v-3.2h2v8.8h0ZM155.2-104.8c0-1-.6-1.7-1.4-1.7s-1.4.7-1.4,1.7.6,1.7,1.4,1.7,1.4-.7,1.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.9-104.8c0,2-1.4,3.3-3.5,3.3s-3.5-1.3-3.5-3.3,1.4-3.3,3.5-3.3,3.5,1.3,3.5,3.3ZM160-104.8c0,1,.6,1.7,1.4,1.7s1.4-.7,1.4-1.7-.6-1.7-1.4-1.7-1.4.7-1.4,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.6-106.9c.4-.7,1.2-1.2,2.1-1.2v1.8c-1.2,0-2,.5-2.1,1.3v3.3h-2v-6.4h2v1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.3-104.8c0,1.9-1.2,3.2-2.9,3.2s-1.5-.3-2-.9v3.1h-2v-8.7h2v.8c.5-.6,1.1-.9,1.9-.9,1.8,0,3,1.3,3,3.3h0ZM177.2-104.8c0-1-.6-1.7-1.4-1.7s-1.4.7-1.4,1.7.6,1.7,1.4,1.7,1.4-.7,1.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.5-105.8v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h-.1ZM183.5-103.8v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.5-106.9c.4-.7,1.2-1.2,2.1-1.2v1.8c-1.2,0-2,.5-2.1,1.3v3.3h-2v-6.4h2v1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.5-105.8v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h-.1ZM194.5-103.8v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.7-104.3h-4.5c.2.8.7,1.2,1.5,1.2s1.1-.2,1.5-.7l1.1,1.1c-.7.7-1.6,1.1-2.8,1.1-2.1,0-3.4-1.3-3.4-3.2s1.3-3.3,3.3-3.3,3.4,1.5,3.2,3.8h0ZM203.8-105.4c0-.8-.5-1.3-1.2-1.3s-1.2.5-1.3,1.3h2.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.4-101.6v-8.8h2v8.8h-2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.3-100.3v-7.6l-2.8,6.4h-1.9l-2.8-6.4v7.6h-2.6v-11.7h3.2l3.2,6.9,3.2-6.9h3.2v11.7h-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.7-100.3h-2.9v-1.5c-.6,1.1-1.6,1.6-2.9,1.6-1.9,0-3.2-1.3-3.2-3.4v-5.7h2.9v4.8c0,1.1.6,1.7,1.5,1.7s1.7-.9,1.7-2.1v-4.4h2.9v9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.8-106v5.7h-2.9v-4.9c0-1-.6-1.7-1.6-1.7s-1.7.8-1.8,1.8v4.7h-2.9v-9h2.9v1.5c.6-1,1.7-1.6,3-1.6,2,0,3.3,1.3,3.3,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.5-100.3h-2.9v-1.2c-.6.8-1.5,1.3-2.7,1.3-2.5,0-4.2-1.9-4.2-4.6s1.6-4.6,4.1-4.6,2.1.5,2.8,1.3v-4.6h2.9v12.4h0ZM255.6-104.8c0-1.4-.8-2.3-2-2.3s-2,.9-2,2.3.8,2.3,2,2.3,2-1,2-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.6-104.8c0,2.8-2,4.6-4.9,4.6s-4.9-1.8-4.9-4.6,2-4.6,4.9-4.6,4.9,1.8,4.9,4.6ZM262.6-104.8c0,1.4.8,2.3,2,2.3s2-.9,2-2.3-.8-2.3-2-2.3-2,.9-2,2.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "121.5 14.3 133.7 14.3 133.7 11.9 121.5 11.9 121.5 3.9 135.1 3.9 135.1 1.4 118.9 1.4 118.9 25.2 135.6 25.2 135.6 22.7 121.5 22.7 121.5 14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.1,10.3c1-.6,2.1-.8,3.3-.8s1.9.2,2.8.6c.8.4,1.5,1,2.1,1.7l.3.4,2-1.5-.3-.4c-.7-1.1-1.7-1.9-2.9-2.5-1.2-.6-2.5-.8-3.9-.8s-3.3.4-4.7,1.2c-1.4.8-2.5,1.9-3.3,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.7,1.2s2.8-.3,3.9-.8c1.2-.6,2.2-1.4,2.9-2.5l.3-.4-2-1.5-.3.4c-.6.8-1.2,1.4-2.1,1.7-.8.4-1.8.6-2.8.6s-2.3-.3-3.3-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.9,16.7c0,1.9-.5,3.4-1.5,4.5s-2.4,1.6-4.2,1.6-2.9-.5-3.8-1.3c-.9-.9-1.3-2.2-1.3-4V7.2h-2.6v10.4c0,2.4.7,4.4,2,5.7,1.3,1.3,3.2,2,5.6,2s3-.4,4.2-1.1c.7-.4,1.3-.9,1.8-1.5v2.4h2.6V7.2h-2.6v9.5h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.1,7c-1.4,0-2.7.2-3.9.7-1.2.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1-1.2-1.2-3-1.7-5.2-1.7h-.1ZM180.5,22.1c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.7,10c-.6-.7-1.3-1.3-2.1-1.8-1.3-.8-2.7-1.1-4.3-1.1s-3.2.4-4.5,1.2c-1.4.8-2.4,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.8,2.5,3.2,3.2,1.4.8,2.9,1.2,4.5,1.2s3.1-.4,4.4-1.1c.8-.5,1.5-1.1,2.1-1.8v2.8h2.6V0h-2.6v10h0ZM200.9,12.7c.6,1,.8,2.2.8,3.5s-.3,2.5-.8,3.5c-.6,1-1.3,1.8-2.3,2.3-.9.6-2,.8-3.2.8s-2.3-.3-3.2-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.3,2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.4,8.2c-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2c-1.4.8-2.5,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2c1.4-.8,2.5-1.9,3.2-3.3.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7-1.9-2.5-3.2-3.3ZM221.1,16.2c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3s-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.8,7c-1.7,0-3.1.4-4.3,1.1-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.5,59.1h-13.1l-2.5,6.1h-6.7l12.6-28.3h6.5l12.6,28.3h-6.9l-2.5-6.1h0ZM135.4,54.2l-4.5-10.8-4.5,10.8h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.2,50.6h6v11.5c-1.5,1.2-3.3,2-5.3,2.7-2,.6-4.1.9-6.1.9-2.9,0-5.6-.6-7.9-1.9s-4.2-3-5.5-5.2-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.6-5.2c2.4-1.3,5-1.9,8-1.9s4.7.4,6.7,1.3c2,.8,3.7,2,5.1,3.6l-4.2,3.9c-2-2.1-4.5-3.2-7.3-3.2s-3.4.4-4.8,1.1c-1.4.8-2.5,1.8-3.3,3.2s-1.2,2.9-1.2,4.7.4,3.3,1.2,4.7,1.9,2.4,3.3,3.2c1.4.8,3,1.2,4.7,1.2s3.6-.4,5.1-1.2v-8.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M193.6,65.2l-5.5-7.9h-6v7.9h-6.5v-28.3h12.2c2.5,0,4.7.4,6.5,1.3,1.8.8,3.3,2,4.3,3.6,1,1.5,1.5,3.4,1.5,5.5s-.5,3.9-1.5,5.4-2.4,2.7-4.3,3.5l6.3,9.1h-7ZM192,43.5c-1-.8-2.5-1.3-4.5-1.3h-5.3v9.9h5.3c2,0,3.5-.4,4.5-1.3,1-.9,1.5-2.1,1.5-3.6s-.5-2.8-1.5-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.9,63.8c-2.4-1.3-4.2-3-5.5-5.2s-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.5-5.2c2.4-1.3,5-1.9,7.9-1.9s5.6.6,7.9,1.9c2.3,1.3,4.2,3,5.5,5.2s2,4.7,2,7.5-.7,5.3-2,7.5-3.2,4-5.5,5.2c-2.3,1.3-5,1.9-7.9,1.9s-5.6-.6-7.9-1.9ZM222.4,58.9c1.3-.8,2.4-1.8,3.2-3.2s1.2-2.9,1.2-4.7-.4-3.3-1.2-4.7-1.8-2.4-3.2-3.2c-1.3-.8-2.9-1.2-4.5-1.2s-3.2.4-4.5,1.2-2.4,1.8-3.2,3.2-1.2,2.9-1.2,4.7.4,3.3,1.2,4.7,1.8,2.4,3.2,3.2c1.3.8,2.9,1.2,4.5,1.2s3.2-.4,4.5-1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.4,79.5c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9c1.2,1,2.8,1.4,4.8,1.4s2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1s-3-1.7-5.2-1.7h-.1ZM126.8,94.5c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 134.6,
    y: 72.4,
    width: 2.6,
    height: 25.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 140.4,
    y: 79.6,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.5,73.3c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168,79.5c-1.7,0-3.2.4-4.5,1.2-1,.6-1.8,1.4-2.3,2.3-.5-1-1.2-1.8-2.1-2.3-1.2-.7-2.6-1.1-4.2-1.1s-3.1.4-4.2,1.1c-.7.4-1.3.9-1.8,1.5v-2.4h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3,1.3,2.3,1.3,4v10.3h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3,1.3,2.3,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-1.9-5.7-1.3-1.3-3.1-2-5.3-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.6,80.6c-1.3-.8-2.8-1.2-4.4-1.2s-3.1.4-4.4,1.2c-1.3.8-2.4,1.9-3.1,3.3-.7,1.4-1.1,3-1.1,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.3,3.2,1.4.8,3,1.2,4.8,1.2s2.7-.3,3.8-.8c1.2-.5,2.2-1.2,3-2.2l.3-.3-1.6-1.8-.4.5c-.6.7-1.3,1.3-2.2,1.6-.9.4-1.8.6-2.9.6s-2.4-.3-3.4-.8-1.8-1.3-2.4-2.2c-.5-.8-.8-1.7-.9-2.8h14.5v-1c0-1.7-.3-3.3-1.1-4.7-.7-1.4-1.8-2.5-3.1-3.2h0ZM179.2,87.2c.1-.9.4-1.8.9-2.5.5-.9,1.2-1.6,2.1-2.1,1.8-1,4.2-1,6,0,.9.5,1.6,1.2,2.1,2.1.5.7.7,1.6.9,2.5h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204,79.5c-1.7,0-3.1.4-4.4,1.1-.7.4-1.4.9-1.9,1.6v-2.5h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.6-4.5,1-1.1,2.5-1.6,4.4-1.6s2.8.4,3.7,1.3,1.3,2.2,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-2-5.7-1.3-1.3-3.1-2-5.4-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.5,94.5c-.6.5-1.4.8-2.3.8s-1.6-.2-2-.7-.7-1.2-.7-2.2v-10.4h5.4v-2.4h-5.4v-3.7h-2.6v3.7h-3.1v2.4h3.1v10.6c0,1.6.5,2.8,1.3,3.8.9.9,2.2,1.4,3.8,1.4s1.4,0,2.1-.3c.7-.2,1.3-.6,1.7-1l.3-.3-1.2-2-.5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.1,79.5c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1s-3-1.7-5.2-1.7h-.1ZM233.5,94.5c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.5,80.5c-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5c-1.7,0-3.1.4-4.3,1.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.2,73.3c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 251.2,
    y: 79.6,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.1,83.9c-.8-1.4-1.9-2.5-3.2-3.3-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2c-1.4.8-2.5,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2c1.4-.8,2.5-1.9,3.2-3.3.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7ZM270.6,88.6c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3-.6-1-.8-2.2-.8-3.5s.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.7,28.3c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.1,2.1c-16.1,0-30.4,8.1-38.9,20.5,1.7-.2,3.3-.3,5-.3,5.4,0,10.7.9,15.5,2.6,5.2-3.7,11.5-5.8,18.3-5.8s13.1,2.1,18.3,5.8c4.8-1.7,10-2.6,15.4-2.6s3.5,0,5.2.3C77.5,10.2,63.2,2.1,47.1,2.1ZM66.2,18.5c-5.8-3.4-12.3-5.2-19.1-5.2s-13.4,1.8-19.2,5.3c-2.2-.6-4.4-1.1-6.7-1.5,7.2-5.8,16.3-9.1,25.9-9.1s18.6,3.3,25.8,9.1c-2.3.3-4.5.8-6.7,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.7,28.3c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.7,28.3c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.5,28.7c-1.6-.1-3.1-.2-4.7-.2-14.7,0-28,6-37.5,15.7-9.6-9.7-22.8-15.7-37.5-15.7s-3.5,0-5.2.3c-.9,1.9-1.7,3.8-2.3,5.8,2.8-.5,5.7-.8,8.7-.8,13,0,24.8,5.3,33.3,13.8s2,2.1,2.9,3.2c1-1.1,2-2.2,3-3.3,8.5-8.5,20.2-13.7,33.2-13.7s5.7.3,8.4.8c-.6-2-1.4-3.9-2.3-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.2,54.6H.3c-.2-1.8-.3-3.6-.3-5.5s.1-3.7.3-5.4l10.9,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.5,41.1v11.1l-11.1-11.1c1.9-.2,3.8-.4,5.8-.4s3.6,0,5.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.6,69H4.4c-1.6-3.5-2.8-7.2-3.6-11.1h13.7l11.1,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.9,45.1v21.5l-11.1-11.1v-13.9c3.9.7,7.6,1.9,11.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40,83.3H14.7c-3.4-3.2-6.3-7-8.7-11.1h22.8l11.1,11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.3,55.4v25.6l-11.1-11.1v-23.1c4.1,2.3,7.9,5.2,11.1,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.5,95.9c-1.8.2-3.6.3-5.4.3s-5.1-.2-7.6-.6c-3-.5-5.8-1.2-8.6-2.2-4.5-1.6-8.6-3.9-12.4-6.8h24.7s9.3,9.3,9.3,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.3,87.9c0,2,0,3.9-.3,5.8l-9.4-9.4v-25.1c.5.7,1,1.4,1.5,2.1,5.2,7.6,8.2,16.7,8.2,26.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.5,
    y: 52.8,
    width: 3.1,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.4,51.3c0-.9.7-1.6,1.6-1.6h6.2c.9,0,1.6.7,1.6,1.6v8h4.7v-12.1c0-.4-.2-.8-.5-1.1l-2.5-2.5c0,0-.3-.2-.4-.3l-3.8-2h0c-2.7.5-5.6,1.2-8.6,2.4l-2.5,2.5c-.3.3-.5.7-.5,1.1v12.1h4.7v-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77,74.9h-16.9c.3,1,.6,2,.9,3.1h12.8l3.1-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.5,93.3s4-1.3,9.2-4.6c4.7-3,10.4-7.7,14.7-14.6,1.7-2.8,3.3-5.9,4.4-9.4-6.3,6.2-24.1,24-28.3,28.2v.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.3,68.7h-25.4c.4,1,.8,2,1.2,3.1h21l3.1-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.7,81.2h-8.9c.2,1,.4,2.1.6,3.1h5.2s3.1-3.1,3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.9,87.4c0,.4,0,.9.2,1.3l1.3-1.3h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.5,62.4h-34.6c.5.9,1,2,1.6,3.1h29.9l3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.2,43.9c.7.7,1.2,1.7,1.3,2.7h5.5c0-1.5-.2-3.1-.4-4.7v-.4s-.5,0-1.4-.3h0c-1.6-.3-4.6-.6-8.3-.4.3.2.6.4.9.7l2.5,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.6,49.7v9.6h4.5c.6-3,.9-6.1.9-9.6h-5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.2,59.3v-3.5c3.6-.6,6.2-3.1,6.2-6.1s-.2-1.8-.6-2.8c-3.6,2.1-7.2,4.8-10.8,8.4.6.3,1.3.5,2,.6v3.5h3.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "795.5 264.5 807.6 264.5 807.6 262 795.5 262 795.5 254 809 254 809 251.5 792.8 251.5 792.8 275.3 809.5 275.3 809.5 272.8 795.5 272.8 795.5 264.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M815.1,260.5c1-.6,2.1-.8,3.3-.8s1.9.2,2.8.6c.8.4,1.5,1,2.1,1.7l.3.4,2-1.5-.3-.4c-.7-1.1-1.7-1.9-2.9-2.5s-2.5-.8-3.9-.8-3.3.4-4.7,1.2c-1.4.8-2.5,1.9-3.3,3.3s-1.2,3-1.2,4.7.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.7,1.2s2.8-.3,3.9-.8c1.2-.6,2.2-1.4,2.9-2.5l.3-.4-2-1.5-.3.4c-.6.8-1.2,1.4-2.1,1.7-.8.4-1.8.6-2.8.6s-2.3-.3-3.3-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M839.9,266.9c0,1.9-.5,3.4-1.5,4.5s-2.4,1.6-4.2,1.6-2.9-.5-3.8-1.3c-.9-.9-1.3-2.2-1.3-4v-10.3h-2.6v10.4c0,2.4.7,4.4,2,5.7,1.3,1.3,3.2,2,5.6,2s3-.4,4.2-1.1c.7-.4,1.3-.9,1.8-1.5v2.4h2.6v-18h-2.6v9.5h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M852,257.2c-1.4,0-2.7.2-3.9.7-1.2.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1s-3-1.7-5.2-1.7h0ZM854.4,272.2c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M875.7,260.1c-.6-.7-1.3-1.3-2.1-1.8-1.3-.8-2.7-1.1-4.3-1.1s-3.2.4-4.5,1.2c-1.4.8-2.4,1.9-3.2,3.3s-1.2,3-1.2,4.7.4,3.3,1.2,4.7c.8,1.4,1.8,2.5,3.2,3.2,1.4.8,2.9,1.2,4.5,1.2s3.1-.4,4.4-1.1c.8-.5,1.5-1.1,2.1-1.8v2.8h2.6v-25.2h-2.6v10h-.1ZM874.8,262.9c.6,1,.8,2.2.8,3.5s-.3,2.5-.8,3.5c-.6,1-1.3,1.8-2.3,2.3-.9.6-2,.8-3.2.8s-2.3-.3-3.2-.8-1.7-1.3-2.3-2.3-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.3,2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M893.3,258.4c-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2c-1.4.8-2.5,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2c1.4-.8,2.5-1.9,3.2-3.3.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7c-.8-1.4-1.9-2.5-3.2-3.3ZM895,266.3c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3s-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M907.7,257.2c-1.7,0-3.1.4-4.3,1.1-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.4,309.3h-13.1l-2.5,6.1h-6.7l12.6-28.3h6.5l12.6,28.3h-6.9l-2.5-6.1h0ZM809.4,304.3l-4.5-10.8-4.5,10.8h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M840.1,300.8h6v11.5c-1.5,1.2-3.3,2-5.3,2.7-2,.6-4.1.9-6.1.9-2.9,0-5.6-.6-7.9-1.9s-4.2-3-5.5-5.2-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.6-5.2c2.4-1.3,5-1.9,8-1.9s4.7.4,6.7,1.3c2,.8,3.7,2,5.1,3.6l-4.2,3.9c-2-2.1-4.5-3.2-7.3-3.2s-3.4.4-4.8,1.1c-1.4.8-2.5,1.8-3.3,3.2-.8,1.4-1.2,2.9-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.4,3.3,3.2,1.4.8,3,1.2,4.7,1.2s3.6-.4,5.1-1.2v-8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M867.5,315.3l-5.5-7.9h-6v7.9h-6.5v-28.3h12.2c2.5,0,4.7.4,6.5,1.3,1.8.8,3.3,2,4.3,3.6,1,1.5,1.5,3.4,1.5,5.5s-.5,3.9-1.5,5.4-2.4,2.7-4.3,3.5l6.3,9.1h-7ZM865.9,293.7c-1-.8-2.5-1.3-4.5-1.3h-5.3v9.9h5.3c2,0,3.5-.4,4.5-1.3s1.5-2.1,1.5-3.6-.5-2.8-1.5-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M883.9,313.9c-2.4-1.3-4.2-3-5.5-5.2s-2-4.7-2-7.5.7-5.3,2-7.5,3.2-4,5.5-5.2c2.4-1.3,5-1.9,7.9-1.9s5.6.6,7.9,1.9c2.3,1.3,4.2,3,5.5,5.2s2,4.7,2,7.5-.7,5.3-2,7.5-3.2,4-5.5,5.2c-2.3,1.3-5,1.9-7.9,1.9s-5.6-.6-7.9-1.9ZM896.3,309.1c1.3-.8,2.4-1.8,3.2-3.2s1.2-2.9,1.2-4.7-.4-3.3-1.2-4.7-1.8-2.4-3.2-3.2c-1.3-.8-2.9-1.2-4.5-1.2s-3.2.4-4.5,1.2c-1.3.8-2.4,1.8-3.2,3.2s-1.2,2.9-1.2,4.7.4,3.3,1.2,4.7,1.8,2.4,3.2,3.2c1.3.8,2.9,1.2,4.5,1.2s3.2-.4,4.5-1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.3,329.6c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1s-3-1.7-5.2-1.7h0ZM800.8,344.7c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 808.5,
    y: 322.6,
    width: 2.6,
    height: 25.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 814.4,
    y: 329.8,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M814.4,323.5c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M841.9,329.6c-1.7,0-3.2.4-4.5,1.2-1,.6-1.8,1.4-2.3,2.3-.5-1-1.2-1.8-2.1-2.3-1.2-.7-2.6-1.1-4.2-1.1s-3.1.4-4.2,1.1c-.7.4-1.3.9-1.8,1.5v-2.4h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3,1.3,2.3,1.3,4v10.3h2.6v-9.6c0-1.9.5-3.4,1.5-4.5s2.4-1.6,4.2-1.6,2.7.4,3.5,1.3,1.3,2.3,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-1.9-5.7-1.3-1.3-3.1-2-5.3-2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M863.5,330.8c-1.3-.8-2.8-1.2-4.4-1.2s-3.1.4-4.4,1.2c-1.3.8-2.4,1.9-3.1,3.3-.7,1.4-1.1,3-1.1,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.3,3.2,1.4.8,3,1.2,4.8,1.2s2.7-.3,3.8-.8c1.2-.5,2.2-1.2,3-2.2l.3-.3-1.6-1.8-.4.5c-.6.7-1.3,1.3-2.2,1.6-.9.4-1.8.6-2.9.6s-2.4-.3-3.4-.8-1.8-1.3-2.4-2.2c-.5-.8-.8-1.7-.9-2.8h14.5v-1c0-1.7-.3-3.3-1.1-4.7-.7-1.4-1.8-2.5-3.1-3.2h.1ZM853.2,337.4c0-.9.4-1.8.9-2.5.5-.9,1.2-1.6,2.1-2.1,1.8-1,4.2-1,6,0,.9.5,1.6,1.2,2.1,2.1.5.7.7,1.6.9,2.5h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M878,329.6c-1.7,0-3.1.4-4.4,1.1-.7.4-1.4.9-1.9,1.6v-2.5h-2.6v18h2.6v-9.6c0-1.9.5-3.4,1.6-4.5,1-1.1,2.5-1.6,4.4-1.6s2.8.4,3.7,1.3,1.3,2.2,1.3,4v10.3h2.6v-10.4c0-2.4-.7-4.4-2-5.7-1.3-1.3-3.1-2-5.4-2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896.4,344.7c-.6.5-1.4.8-2.3.8s-1.6-.2-2-.7-.7-1.2-.7-2.2v-10.4h5.4v-2.4h-5.4v-3.7h-2.6v3.7h-3.1v2.4h3.1v10.6c0,1.6.5,2.8,1.3,3.8.9.9,2.2,1.4,3.8,1.4s1.4-.1,2.1-.3c.7-.2,1.3-.6,1.7-1l.3-.3-1.2-2-.5.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M905.1,329.6c-1.4,0-2.7.2-3.9.7-1.3.4-2.3,1.1-3.2,1.9l-.3.3,1.4,2,.4-.4c.7-.6,1.5-1.1,2.5-1.5s2-.6,3.1-.6,2.7.4,3.4,1.1c.8.7,1.1,1.8,1.1,3.3v.9h-5.3c-2.3,0-4.1.5-5.2,1.4-1.1,1-1.7,2.3-1.7,3.8s.6,2.9,1.8,3.9,2.8,1.4,4.8,1.4,2.9-.3,4-.9c.6-.3,1.2-.7,1.6-1.2v2h2.6v-11.3c0-2.2-.6-3.9-1.8-5.1s-3-1.7-5.2-1.7h0ZM907.5,344.7c-.9.6-2,.9-3.3.9s-2.4-.3-3.2-.9c-.7-.5-1-1.3-1-2.2s.3-1.6.9-2.1c.7-.5,1.8-.8,3.3-.8h5.3v2.6c-.5,1.1-1.1,1.9-2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M919.5,330.7c-.7.4-1.2.9-1.7,1.5v-2.4h-2.6v18h2.6v-9.4c0-2,.5-3.5,1.5-4.6s2.3-1.6,4-1.6h.9v-2.6h-.5c-1.7,0-3.1.4-4.3,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M925.2,323.5c-.4.4-.5.8-.5,1.3s.2.9.5,1.3h0c.4.3.8.5,1.3.5s.9-.2,1.3-.5c.4-.4.5-.8.5-1.3s-.2-.9-.5-1.3c-.7-.7-1.9-.7-2.6,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 925.1,
    y: 329.8,
    width: 2.6,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M946,334.1c-.8-1.4-1.9-2.5-3.2-3.3-1.4-.8-2.9-1.2-4.6-1.2s-3.2.4-4.6,1.2c-1.4.8-2.5,1.9-3.2,3.3-.8,1.4-1.2,3-1.2,4.7s.4,3.3,1.2,4.7c.8,1.4,1.9,2.5,3.2,3.3,1.4.8,2.9,1.2,4.6,1.2s3.2-.4,4.6-1.2c1.4-.8,2.5-1.9,3.2-3.3.8-1.4,1.2-3,1.2-4.7s-.4-3.3-1.2-4.7ZM944.5,338.8c0,1.3-.3,2.5-.8,3.5s-1.3,1.8-2.3,2.3-2,.8-3.2.8-2.3-.3-3.2-.8c-.9-.6-1.7-1.3-2.3-2.3s-.8-2.2-.8-3.5.3-2.5.8-3.5,1.3-1.8,2.3-2.3c.9-.6,2-.8,3.2-.8s2.3.3,3.2.8c.9.6,1.7,1.4,2.3,2.3.6,1,.8,2.2.8,3.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 786.8,
    y1: 359.3,
    x2: 950.9,
    y2: 359.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 786.8,
    y: 358.8,
    width: 164.1,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.7,278.5c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M721,252.2c-16.1,0-30.4,8.1-38.9,20.5,1.7-.2,3.3-.3,5-.3,5.4,0,10.7.9,15.5,2.6,5.2-3.7,11.5-5.8,18.3-5.8s13.1,2.1,18.3,5.8c4.8-1.7,10-2.6,15.4-2.6s3.5,0,5.2.3c-8.5-12.4-22.7-20.5-38.9-20.5h.1ZM740.1,268.6c-5.8-3.4-12.3-5.2-19.1-5.2s-13.4,1.8-19.2,5.3c-2.2-.6-4.4-1.1-6.7-1.5,7.2-5.8,16.3-9.1,25.9-9.1s18.6,3.3,25.8,9.1c-2.3.3-4.5.8-6.7,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.7,278.5c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.7,278.5c-1.6.9-3.2,1.9-4.7,3h0c-1.9-.5-3.9-.8-6-.8s-4.2.3-6.1.8c-1.5-1.1-3-2.1-4.6-3,3.2-1.7,6.9-2.6,10.8-2.6s7.5.9,10.7,2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.5,278.9c-1.6-.1-3.1-.2-4.7-.2-14.7,0-28,6-37.5,15.7-9.6-9.7-22.8-15.7-37.5-15.7s-3.5,0-5.2.3c-.9,1.9-1.7,3.8-2.3,5.8,2.8-.5,5.7-.8,8.7-.8,13,0,24.8,5.3,33.3,13.8s2,2.1,2.9,3.2c1-1.1,2-2.2,3-3.3,8.5-8.5,20.2-13.7,33.2-13.7s5.7.3,8.4.8c-.6-2-1.4-3.9-2.3-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M685.1,304.8h-10.9c-.2-1.8-.3-3.6-.3-5.5s0-3.7.3-5.4l10.9,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.5,291.3v11.1l-11.1-11.1c1.9-.2,3.8-.4,5.8-.4s3.6.1,5.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M699.5,319.1h-21.2c-1.6-3.5-2.8-7.2-3.6-11.1h13.7l11.1,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M701.8,295.3v21.5l-11.1-11.1v-13.9c3.9.7,7.6,1.9,11.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713.9,333.5h-25.2c-3.4-3.2-6.3-7-8.7-11.1h22.8l11.1,11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M716.2,305.6v25.6l-11.1-11.1v-23.1c4.1,2.3,7.9,5.2,11.1,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M726.5,346.1c-1.8.2-3.6.3-5.4.3s-5.1-.2-7.6-.6c-3-.5-5.8-1.2-8.6-2.2-4.5-1.6-8.6-3.9-12.4-6.8h24.7l9.3,9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M729.2,338.1c0,2,0,3.9-.3,5.8l-9.4-9.4v-25.1c.5.7,1,1.4,1.5,2.1,5.2,7.6,8.2,16.7,8.2,26.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.5,
    y: 303,
    width: 3.1,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.3,301.5c0-.9.7-1.6,1.6-1.6h6.2c.9,0,1.6.7,1.6,1.6v8h4.7v-12.1c0-.4-.2-.8-.5-1.1l-2.5-2.5c0-.1-.3-.2-.4-.3l-3.8-2h0c-2.7.5-5.6,1.2-8.6,2.4l-2.5,2.5c-.3.3-.5.7-.5,1.1v12.1h4.7v-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.9,325.1h-16.9c.3,1,.6,2,.9,3.1h12.8l3.1-3.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M737.4,343.5s4-1.3,9.2-4.6c4.7-3,10.4-7.7,14.7-14.6,1.7-2.8,3.3-5.9,4.4-9.4-6.3,6.2-24.1,24-28.3,28.2v.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M757.2,318.9h-25.4c.4,1,.8,2,1.2,3.1h21l3.1-3.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M744.7,331.4h-8.9c.2,1,.4,2.1.6,3.1h5.2l3.1-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.9,337.6c0,.4,0,.9.2,1.3l1.3-1.3h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.4,312.6h-34.6c.5.9,1,2,1.6,3.1h29.9l3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M761.1,294.1c.7.7,1.2,1.7,1.3,2.7h5.5c0-1.5-.2-3.1-.4-4.7v-.4s-.5-.1-1.4-.3h0c-1.6-.3-4.6-.6-8.3-.4.3.2.6.4.9.7l2.5,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.5,299.9v9.6h4.5c.6-3,.9-6.1.9-9.6h-5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.2,309.5v-3.5c3.6-.6,6.2-3.1,6.2-6.1s-.2-1.8-.6-2.8c-3.6,2.1-7.2,4.8-10.8,8.4.6.3,1.3.5,2,.6v3.5h3.2Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M793.4,371.1v1.6h4v1.7h-4v1.7h4.5v1.7h-6.6v-8.3h6.5v1.7h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M804.4,372.7l-1.5.9c-.3-.4-.7-.7-1.3-.7s-1.3.7-1.3,1.6.5,1.6,1.3,1.6,1-.2,1.3-.7l1.5.9c-.5.9-1.6,1.5-2.9,1.5-2,0-3.3-1.3-3.3-3.2s1.3-3.3,3.3-3.3,2.3.5,2.8,1.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.1,377.8h-2v-1.1c-.4.8-1.1,1.1-2.1,1.1s-2.3-.9-2.3-2.4v-4h2v3.4c0,.8.4,1.2,1.1,1.2s1.2-.7,1.2-1.5v-3.1h2v6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M817.9,373.6v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h0ZM815.9,375.6v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M825.3,377.8h-2v-.8c-.5.6-1.1.9-1.9.9-1.8,0-3-1.3-3-3.3s1.2-3.2,2.9-3.2,1.5.3,2,.9v-3.2h2v8.8h0ZM823.2,374.6c0-1-.6-1.7-1.4-1.7s-1.4.7-1.4,1.7.6,1.7,1.4,1.7,1.4-.7,1.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.9,374.6c0,2-1.4,3.3-3.5,3.3s-3.5-1.3-3.5-3.3,1.4-3.3,3.5-3.3,3.5,1.3,3.5,3.3ZM828,374.6c0,1,.6,1.7,1.4,1.7s1.4-.7,1.4-1.7-.6-1.7-1.4-1.7-1.4.7-1.4,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M835.5,372.5c.4-.7,1.2-1.2,2.1-1.2v1.8c-1.2-.1-2,.5-2.1,1.3v3.3h-2v-6.4h2v1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M847.3,374.6c0,1.9-1.2,3.2-2.9,3.2s-1.5-.3-2-.9v3.1h-2v-8.7h2v.8c.5-.6,1.1-.9,1.9-.9,1.8,0,3,1.3,3,3.3h0ZM845.2,374.5c0-1-.6-1.7-1.4-1.7s-1.4.7-1.4,1.7.6,1.7,1.4,1.7,1.4-.7,1.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M853.5,373.6v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h0ZM851.5,375.6v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M856.5,372.5c.4-.7,1.2-1.2,2.1-1.2v1.8c-1.2-.1-2,.5-2.1,1.3v3.3h-2v-6.4h2v1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.5,373.6v4.2h-2v-.7c-.4.5-1.1.8-2,.8-1.4,0-2.2-.8-2.2-2s.9-1.9,2.5-1.9h1.7c0-.7-.4-1.1-1.2-1.1s-1.2.2-1.9.5l-.6-1.4c1-.5,1.9-.7,3-.7,1.8,0,2.8.9,2.8,2.3h0ZM862.5,375.6v-.6h-1.3c-.6,0-.9.2-.9.7s.3.8.9.8,1.2-.4,1.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M873.7,375.1h-4.5c.2.8.7,1.2,1.5,1.2s1.1-.2,1.5-.7l1.1,1.1c-.7.7-1.6,1.1-2.8,1.1-2.1,0-3.4-1.3-3.4-3.2s1.3-3.3,3.3-3.3,3.4,1.5,3.2,3.8h.1ZM871.7,374c0-.8-.5-1.3-1.2-1.3s-1.2.5-1.3,1.3h2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874.4,377.8v-8.8h2v8.8h-2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M891.3,379.1v-7.6l-2.8,6.4h-1.9l-2.8-6.4v7.6h-2.6v-11.7h3.2l3.2,6.9,3.2-6.9h3.2v11.7h-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.7,379.1h-2.9v-1.5c-.6,1.1-1.6,1.6-2.9,1.6-1.9,0-3.2-1.3-3.2-3.4v-5.7h2.9v4.8c0,1.1.6,1.7,1.5,1.7s1.7-.9,1.7-2.1v-4.4h2.9v9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M915.7,373.4v5.7h-2.9v-4.9c0-1-.6-1.7-1.6-1.7s-1.7.8-1.8,1.8v4.7h-2.9v-9h2.9v1.5c.6-1,1.7-1.6,3-1.6,2,0,3.3,1.3,3.3,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M926.5,379.1h-2.9v-1.2c-.6.8-1.5,1.3-2.7,1.3-2.5,0-4.2-1.9-4.2-4.6s1.6-4.6,4.1-4.6,2.1.5,2.8,1.3v-4.6h2.9v12.4h0ZM923.6,374.6c0-1.4-.8-2.3-2-2.3s-2,.9-2,2.3.8,2.3,2,2.3,2-1,2-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M937.6,374.6c0,2.8-2,4.6-4.9,4.6s-4.9-1.8-4.9-4.6,2-4.6,4.9-4.6,4.9,1.8,4.9,4.6ZM930.6,374.6c0,1.4.8,2.3,2,2.3s2-.9,2-2.3-.8-2.3-2-2.3-2,.9-2,2.3Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanco);
export default __webpack_public_path__ + "static/media/logoBlanco.617e2c527d660d844878e9423058de27.svg";
export { ForwardRef as ReactComponent };